export default __webpack_public_path__ + "static/media/EM1850.34I-42460_-25445_0.c260ff21.jpg";